/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 0
// module chunks = main